// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-exercises-container {
  display: flex;
  height: 100vh;
  font-family: 'Rubik', sans-serif;
}

.left-section {
  margin-top: 20px;
  flex: 1 1;
  border-right: 1px solid black;
  padding: 20px;
}

.right-section {
  flex: 2 1;
  padding: 20px;
  margin-top: 20px;
}

h2 {
  text-align: center;
}

.controls-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.custom-dropdown {
  width: 100%;
  max-width: 250px;
}

.btn-create12 {
  padding: 10px 15px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #388E3C !important;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  gap: 5px;
  width: 155px;
}

.btn-create:hover {
  background: #2E7D32 !important;
}

.error-text {
  color: red;
  text-align: center;
}

.video-container {
  background-color: #A5D6A7;
  border-radius: 20px;
  padding: 0;
  text-align: center;
  height: 359px;
  max-width: 300px;
  margin: 20px auto;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.video-thumbnail {
  width: 100%;
  border-radius: 12px 12px 0 0; 
  display: block; 
  margin: 0; 
  padding: 0; 
}

.selected-exercise-title {
  font-size: 24px;
  margin: 10px 0;
  font-weight: bold;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 15px;
}

.action-buttons button {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s;
}

.action-buttons button:hover {
  opacity: 0.8;
}

.btn-edit {
  background: #007bff;
  color: white;
}

.btn-delete {
  background: #dc3545;
  color: white;
}

.centered-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35%;
  text-align: center;
  font-size: 1.2rem;
  color: black;
}

.watch-video-btn {
  display: inline-block;
  padding: 8px 16px;
  background-color: #388E3C;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  font-weight: 500;
  margin-top: 5px;
  transition: background-color 0.3s;
}

.watch-video-btn:hover {
  background-color: #2E7D32;
}

.success-message-container {
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  pointer-events: none;
}

.success-message16 {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 12px 20px;
  border-radius: 15px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: inline-flex;
  align-items: center;
  max-width: 60% !important;
  text-align: center;
  animation: fadeInOut 3s ease-in-out forwards;
}

.error-message16 {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 12px;
  border-radius: 10px;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 10px auto !important; 
  font-weight: 600;
  width: 40%;
  justify-content: center !important;
  text-align: center;
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(-20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.delete-modal {
  background-color: #A5D6A7;
  padding: 25px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.delete-modal h3 {
  margin-top: 0;
  color: #d32f2f;
  font-size: 1.3rem;
}

.delete-modal p {
  margin: 15px 0 25px;
  color: #555;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.modal-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.modal-cancel {
  background-color: #f0f0f0;
  color: #333;
}

.modal-cancel:hover {
  background-color: #e0e0e0;
}

.modal-confirm {
  background-color: #d32f2f;
  color: white;
}

.modal-confirm:hover {
  background-color: #b71c1c;
}

.exercise-description {
  margin: 10px 0;
  padding: 0 15px;
  color: #555;
  font-size: 0.9rem;
  line-height: 1.4;
}`, "",{"version":3,"sources":["webpack://./src/styles/AdminExercisesPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;AACnD;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".admin-exercises-container {\n  display: flex;\n  height: 100vh;\n  font-family: 'Rubik', sans-serif;\n}\n\n.left-section {\n  margin-top: 20px;\n  flex: 1;\n  border-right: 1px solid black;\n  padding: 20px;\n}\n\n.right-section {\n  flex: 2;\n  padding: 20px;\n  margin-top: 20px;\n}\n\nh2 {\n  text-align: center;\n}\n\n.controls-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.custom-dropdown {\n  width: 100%;\n  max-width: 250px;\n}\n\n.btn-create12 {\n  padding: 10px 15px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: #388E3C !important;\n  color: white;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  width: 155px;\n}\n\n.btn-create:hover {\n  background: #2E7D32 !important;\n}\n\n.error-text {\n  color: red;\n  text-align: center;\n}\n\n.video-container {\n  background-color: #A5D6A7;\n  border-radius: 20px;\n  padding: 0;\n  text-align: center;\n  height: 359px;\n  max-width: 300px;\n  margin: 20px auto;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.video-thumbnail {\n  width: 100%;\n  border-radius: 12px 12px 0 0; \n  display: block; \n  margin: 0; \n  padding: 0; \n}\n\n.selected-exercise-title {\n  font-size: 24px;\n  margin: 10px 0;\n  font-weight: bold;\n}\n\n.action-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n  margin-top: 15px;\n}\n\n.action-buttons button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.action-buttons button:hover {\n  opacity: 0.8;\n}\n\n.btn-edit {\n  background: #007bff;\n  color: white;\n}\n\n.btn-delete {\n  background: #dc3545;\n  color: white;\n}\n\n.centered-message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 35%;\n  text-align: center;\n  font-size: 1.2rem;\n  color: black;\n}\n\n.watch-video-btn {\n  display: inline-block;\n  padding: 8px 16px;\n  background-color: #388E3C;\n  color: white;\n  text-decoration: none;\n  border-radius: 5px;\n  font-weight: 500;\n  margin-top: 5px;\n  transition: background-color 0.3s;\n}\n\n.watch-video-btn:hover {\n  background-color: #2E7D32;\n}\n\n.success-message-container {\n  position: fixed;\n  top: 70px;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.success-message16 {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  padding: 12px 20px;\n  border-radius: 15px;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  display: inline-flex;\n  align-items: center;\n  max-width: 60% !important;\n  text-align: center;\n  animation: fadeInOut 3s ease-in-out forwards;\n}\n\n.error-message16 {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 12px;\n  border-radius: 10px;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  margin: 10px auto !important; \n  font-weight: 600;\n  width: 40%;\n  justify-content: center !important;\n  text-align: center;\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translateY(-20px); }\n  10% { opacity: 1; transform: translateY(0); }\n  90% { opacity: 1; transform: translateY(0); }\n  100% { opacity: 0; transform: translateY(-20px); }\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.delete-modal {\n  background-color: #A5D6A7;\n  padding: 25px;\n  border-radius: 8px;\n  width: 400px;\n  max-width: 90%;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.delete-modal h3 {\n  margin-top: 0;\n  color: #d32f2f;\n  font-size: 1.3rem;\n}\n\n.delete-modal p {\n  margin: 15px 0 25px;\n  color: #555;\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.modal-button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.modal-cancel {\n  background-color: #f0f0f0;\n  color: #333;\n}\n\n.modal-cancel:hover {\n  background-color: #e0e0e0;\n}\n\n.modal-confirm {\n  background-color: #d32f2f;\n  color: white;\n}\n\n.modal-confirm:hover {\n  background-color: #b71c1c;\n}\n\n.exercise-description {\n  margin: 10px 0;\n  padding: 0 15px;\n  color: #555;\n  font-size: 0.9rem;\n  line-height: 1.4;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
